// utilities/apiUtils.ts

import { config } from "@config/config";
import { getLocale } from "./getLocaleOnSSR";

interface ApiRequestOptions extends Omit<RequestInit, "headers"> {
  token?: string;
  bodyData?: any;
  isFormData?: boolean;
  headers?: Record<string, string>;
}

export const apiRequest = async <T>(
  url: string,
  {
    token,
    bodyData,
    isFormData = false,
    headers = {},
    ...options
  }: ApiRequestOptions = {},
): Promise<T> => {
  try {
    const locale = await getLocale();

    const defaultHeaders: Record<string, string> = {
      ...headers,
      "Accept-Language": locale,
    };

    if (!isFormData && !defaultHeaders["Content-Type"]) {
      defaultHeaders["Content-Type"] = "application/json";
    }

    if (token) {
      defaultHeaders["Authorization"] = `Bearer ${token}`;
    }

    const requestOptions: RequestInit = {
      ...options,
      headers: defaultHeaders,
    };

    if (bodyData) {
      requestOptions.body = isFormData ? bodyData : JSON.stringify(bodyData);
    }

    // console.log(requestOptions);
    // console.log(`${config.base_url}${url}`);

    const response = await fetch(`${config.base_url}${url}`, requestOptions);

    if (!response.ok) {
      let errorMessage = `Error ${response.status}: ${response.statusText}`;
      try {
        const errorData = await response.json();
        errorMessage =
          errorData.error?.message || errorData.message || errorMessage;
      } catch {
        // Ignore parsing errors
      }
      throw new Error(errorMessage);
    }

    if (response.status !== 204) {
      const data = (await response.json()) as T;
      return data;
    }

    return null as unknown as T;
  } catch (error) {
    console.error("API Request Error:", error);
    throw error;
  }
};
